import script from "./TutorQualificationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorQualificationForm.vue?vue&type=script&setup=true&lang=js"

import "./TutorQualificationForm.vue?vue&type=style&index=0&id=08e37b03&scoped=true&lang=css"
import "./TutorQualificationForm.vue?vue&type=style&index=1&id=08e37b03&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e37b03"]])

export default __exports__